import { Done, Close, QuestionMark } from '@mui/icons-material';

const formateBoolean = (data) => {
    switch (data) {
        case true:
            return 'Yes';
        case false:
            return 'No';
        default:
            return 'No';
    }
};

export default formateBoolean;

const getStatusLabel = (status) => {
    switch (status) {
        case '1':
            return 'Active';
        case '2':
            return 'Deactive';
        case '3':
            return 'Terminated';
        case 'active':
            return 'Active';
        case 'deactive':
            return 'Deactive';
        case 'draft':
            return 'Draft';
        default:
            return 'Active';
    }
};

const getVerificationLabel = (status) => {
    switch (status) {
        case '0':
            return 'Not Approvd';
        case '1':
            return 'Approved';
        default:
            return 'Not Approvd';
    }
};

const getVerificationColor = (status) => {
    switch (status) {
        case '0':
            return 'error';
        case '1':
            return 'success';
        default:
            return 'error';
    }
};

const getVerificationIcon = (status) => {
    switch (status) {
        case '0':
            return <Close />;
        case '1':
            return <Done />;
        default:
            return <Close />;
    }
};

const getStatusColor = (status) => {
    switch (status) {
        case '1':
            return 'success';
        case '2':
            return 'default';
        case '3':
            return 'error';
        case 'active':
            return 'success';
        case 'deactive':
            return 'error';
        case 'draft':
            return 'primary';
        default:
            return 'success';
    }
};

const getStatusIcon = (status) => {
    switch (status) {
        case '1':
            return <Done />;
        case '2':
            return <QuestionMark />;
        case '3':
            return <Close />;
        case 'active':
            return <Done />;
        case 'deactive':
            return <Close />;
        case 'draft':
            return <QuestionMark />;

        default:
            return <Done />;
    }
};
const addDate = (dt, amount, dateType) => {
    switch (dateType) {
        case 'days':
            return dt.setDate(dt.getDate() + amount) && dt;
        case 'weeks':
            return dt.setDate(dt.getDate() + 7 * amount) && dt;
        case 'months':
            return dt.setMonth(dt.getMonth() + amount) && dt;
        case 'years':
            return dt.setFullYear(dt.getFullYear() + amount) && dt;
        default:
            return dt;
    }
};
const convertStringToArray = (string) => {
    if (!string) {
        return string;
    }
    const str = String(string)
        ?.replace(/\s+/g, '  ')
        ?.split(' ')
        ?.filter((i) => i)
        ?.slice(0, 2);
    return str;
};

const isNegative = (num = 0) => {
    if (num < 0) {
        return true;
    }

    return false;
};

export {
    getStatusLabel,
    getStatusColor,
    getStatusIcon,
    addDate,
    convertStringToArray,
    isNegative,
    getVerificationLabel,
    getVerificationIcon,
    getVerificationColor
};
